import {
  isChildMode,
  isLabPreviewSceneId,
  LAB_SCENE_PARAM,
  type LabPreviewSceneId,
} from '@game-platform/theme-constructor';

/**
 * The lab state the Design Constructor's preview asks for (`?lab_scene=`), in child mode only; null anywhere else, and
 * for a state this build does not know, which leaves the page exactly as it is without one.
 */
export function readLabPreviewScene(): LabPreviewSceneId | null {
  if (typeof window === 'undefined' || !isChildMode()) return null;
  const scene = new URLSearchParams(window.location.search).get(LAB_SCENE_PARAM);
  return isLabPreviewSceneId(scene) ? scene : null;
}
